<!--新增详情设置  -->
<template>
<div>
    <el-row class="mg-tb-20">
        <el-button type="primary" icon="el-icon-plus" @click="addDialog()">新增培训城市</el-button>
    </el-row>            
    <el-table border :data="tableData" style="width: 100%;">         
        <el-table-column  prop="eventDate"  label="培训开始日期" width="120" />
        <el-table-column  prop="eventDate2"  label="培训结束日期" width="120" />
        <el-table-column  prop="eventTimeStr"    label="培训时间" width="140"/>
        <el-table-column  prop="amount"  label="人数" width="120"/>
        <el-table-column  prop="city"  label="城市" width="120"/>
        <el-table-column  prop="eventPlace"  label="详细地址"/>
        <el-table-column  fixed="right" label="操作"  width="180">
            <template slot-scope="scope" >
                <el-button @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="addLecturerDialog(scope.row)" type="text" size="medium">设置讲师</el-button>
                <el-button @click="deleteDialog(scope.row)" type="text" size="medium">删除</el-button>
            </template>                   
        </el-table-column>
    </el-table> 
    <el-row class="mg-t-20">
        <lecturer  :publishId="publishId" :trainId="trainId" :show="isShow"   ref="lecturerRef"></lecturer>
    </el-row>
    <el-dialog :title="titleForm" :visible="showAddTrainDialog" width="600px" :before-close="handleClose" append-to-body>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">                
        <el-row>
        <el-form-item label="地区" prop="area">
            <el-select v-model="ruleForm.provinces"  style="width:45%" @change="handleChangeArea">
                <el-option
                    v-for="item in areaList"
                    :key="item.code"
                    :label="item.label"
                    :value="item.label"
                    >
                </el-option>
            </el-select>
            <el-select v-model="ruleForm.city" style="width:45%" @change="handleChangecity">
                <el-option
                    v-for="item in cityList"
                    :key="item.code"
                    :label="item.label"
                    :value="item.label"
                    >
                </el-option>
                </el-select>
        </el-form-item>
    </el-row>
    <el-row>         
        <el-form-item label="培训地点" prop="eventPlace">
            <el-input type="text" v-model="ruleForm.eventPlace" placeholder="请输入详细地址"/>
        </el-form-item>                 
    </el-row> 
    <el-row>
        <el-col>
            <el-form-item label="培训人数" prop="amount">
                <el-input type="text" v-model="ruleForm.amount" placeholder="请输入内容">
                    <template slot="append">人</template>
                </el-input>
            </el-form-item>   
        </el-col>     
        <!-- <el-col :span="12">
            <el-form-item label="签到时间" prop="signTime">
                <el-input type="text" v-model="ruleForm.signTime" placeholder="请输入内容">
                    <template slot="append">分</template>
                </el-input>
            </el-form-item>     
        </el-col>     -->
    </el-row>
    <el-row> 
        <!--<el-form-item label="报名日期" prop="applyDate">
            <el-date-picker
            v-model="ruleForm.applyDate"
            @change="selectApplyDate"
            type="daterange"                        
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
         <el-col :span="6">
            <el-form-item label="报名时间" prop="applyTime">
                <el-time-picker
                    is-range
                    v-model="ruleForm.applyTime"
                    @change="selectApplyTime"
                    value-format="HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围">
                </el-time-picker>       
            </el-form-item>
        </el-col> -->
    </el-row>
    <el-row> 
        <el-form-item label="培训开始日期" prop="eventDate">
            <el-date-picker
                v-model="ruleForm.eventDate"
                value-format="yyyy-MM-dd"
                type="date"
                :picker-options="pickerOptions"
                @change="selectEventDate"
                placeholder="请选择开始日期">
                </el-date-picker>
        </el-form-item>   
    </el-row>
    <el-row> 
        <el-form-item label="培训结束日期" prop="eventDate2">
            <el-date-picker
                v-model="ruleForm.eventDate2"
                value-format="yyyy-MM-dd"
                type="date"
                :picker-options="pickerOptions"
                @change="selectEventEndDate"
                placeholder="请选择结束日期">
                </el-date-picker>
        </el-form-item>   
    </el-row>
    <el-row>
        <el-form-item label="培训时间" prop="eventTime">
            <el-time-picker
                is-range
                v-model="ruleForm.eventTime" 
                @change="selectEventTime"                       
                value-format="HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
            </el-time-picker>      
        </el-form-item>
    </el-row>
    <el-form-item>
        <el-button type="primary" @click="trainForm('ruleForm')" class="pub-submit">确定</el-button>
        <el-button @click="cancel">取 消</el-button>
    </el-form-item>
    </el-form>
</el-dialog>
</div>
</template>

<script>
import areaList from '@/assets/js/city'
import list2 from '@/config/trainDes2'
import Lecturer from './lecturer.vue'
export default {
    props:{
        publishId: {
            type: String,
            default: ''
        },
        // visible:{
        //     type: Boolean,
        //     default: false,
        // },
        // titleForm:{
        //     type: String,
        //     default: ''
        // },
        // obj: {
        //     type: Object,
        //     default:{}
        // }
    },
    components:{
        Lecturer,
    },
    data() {
        const selectAddress = (rule,value,callback)=>{
            if(this.ruleForm.provinces === ''){
                callback(new Error('请选择省份'))
            }else if( this.ruleForm.city === ''){
                callback(new Error('请选择城市'))
            }else{
                callback()
            }
        }
        return {
            isShow:false,
            titleForm:'',
            ruleForm: list2,
            areaList: areaList.provinces,
            cityList: [],
            rules:{
                eventPlace:[
                    { required: true, message: '请输入培训地点', trigger: 'blur' },
                ],
                area: [
                    { required: true, validator: selectAddress,
                        message: '请选择地区', trigger: 'change' },
                ],
                amount: [
                    { required: true, message: '请输入培训人数', trigger: 'blur' },
                ],
                signTime: [
                    { required: true, message: '请输入签到时间', trigger: 'blur' },
                ],
                applyDate: [
                    { required: false, message: '请选择报名日期', trigger: 'change' },
                ],
                applyTime: [
                    { required: false, message: '请选择报名时间', trigger: 'change' },
                ],
                eventDate: [
                    { required: true, message: '选择培训开始日期', trigger: 'change' },
                ],
                eventDate2: [
                    { required: true, message: '选择培训结束日期', trigger: 'change' },
                ],
                eventTime: [
                    { required: true, message: '选择培训时间', trigger: 'change' },
                ],
            },
            tableData:[],
            showAddTrainDialog: false,
            trainId:1,
            pickerOptions: {
                disabledDate(v) {
                    return v.getTime() < new Date().getTime() - 86400000;
                }
            },
        }
    },
    created() {
        // console.log("created")
        this.trainDetailData()
    },
    mounted() {
        // console.log("mounted")
    },
    methods: {
        trainDetailData(){
            let params = {
                opcode: this.$code.TrainDetailQuery,
                i_serial_train: this.publishId,
                id: '',
                c_status: '',
                start_date: '',
                end_date: '',
                v_economize: '',
                v_city: '',
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable

                    let list = result.map(item=>{
                        // let startDate = this.$help.formatDate(item['报名开始日期'])
                        // let endDate = this.$help.formatDate(item['报名截止日期'])
                        let eventDate = this.$help.formatDate(item['开始日期'])
                        let eventDate2 = this.$help.formatDate(item['结束日期'])
                        let startTime = this.$help.formatTime(item['开始时间'])
                        let endTime = this.$help.formatTime(item['结束时间'])
                        return{
                            serial: item['序号'],
                            title: item['培训标题'],
                            amount: item['人数'],
                            eventPlace: item['具体地点'],
                            serialRemark: item['培训标识'],
                            provinces:item['省'],
                            city: item['市'],
                            // applyDateStr: startDate + '~' + endDate,
                            // applyDate: [startDate,endDate],
                            // applyStartDate: item['报名开始日期'],
                            // applyEndDate: item['报名截止日期'],
                            // 培训日期
                            eventDate: eventDate,
                            eventDate2: eventDate2,
                            eventStartDate:item['开始日期'],
                            eventEndDate:item['结束日期'],
                            eventStartTime: item['开始时间'],
                            eventEndTime: item['结束时间'],
                            eventTimeStr: startTime + '~' + endTime,
                            eventTime: [startTime,endTime],
                            status: item['培训状态'],
                        }
                    })
                    // console.log(list)
                    this.tableData = list
                }else{
                    this.detailList = {}
                }
            })
        },
         // 培训详情设置
         trainForm(formName){
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.trainSubmit()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        // 培训详情设置 提交
        trainSubmit(){
            let {eventPlace, provinces, city, amount, 
                eventStartDate, eventEndDate,eventStartTime, eventEndTime} = this.ruleForm

            if( this.ruleForm.eventDate > this.ruleForm.eventDate2){
                this.$message.error('开始日期不能大于结束日期')
                return false
            }
            // 修改 TrainDesUpdate 60  新增 TrainDesSetting 56
            let opcode = this.publishId && this.ruleForm.serial ? this.$code.TrainDesUpdate : this.$code.TrainDesSetting  
            let params = {}
            let addParams = {
                opcode: opcode,
                i_serial_train: this.publishId,
                // 报名开始日期
                i_start_entry: 0,
                // 报名截止日期
                i_end_entry: 0,
                // 培训开始日期
                i_start_date: eventStartDate,
                // 培训截止日期
                i_end_date: eventEndDate,
                // 培训开始时间
                i_start_time: eventStartTime,
                // 结束时间
                i_end_time: eventEndTime,
                v_economize: provinces,
                v_city: city,
                v_location: eventPlace,
                n_peoples: amount,
                i_timer: 0,
            }
            let updateParams = {
                id: this.ruleForm.serial,
            }
            if(this.publishId && this.ruleForm.serial){
                // console.log("更新")
                params =  Object.assign({}, addParams, updateParams)
            }else{
                // console.log("新增")
                params = addParams
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) { 
                    this.showAddTrainDialog = false
                    this.trainDetailData()
                    this.$message.success('培训详情设置成功')                                      
                }else{
                    this.$message.error(res.Message)
                }
            })    
        },
        addDialog(){
            this.titleForm = "新增培训详情"
            this.showAddTrainDialog = true
            this.ruleForm.serial = ''
        },
        addLecturerDialog(row){
            // console.log(row.serial)
            this.isShow = true
            this.trainId = row.serial
            if(this.trainId){
                this.$refs.lecturerRef.initData(this.trainId)
            }            
        },
        updateDialog(row){
            console.log('修改',row)
            this.ruleForm = {...row};
            this.titleForm = "修改培训详情"
            this.showAddTrainDialog = true
        },
        deleteDialog(row){
            this.$confirm(`确认删除培训${row.city}城市吗？`,'警告',{
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(res=>{
                console.log("object")
                this.submitForm(row)
            }).catch(err=>{
                console.log("取消")
            })
        },
        submitForm(row){
            let params = {
                opcode: this.$code.TrainCityDelete,
                i_serial_train: row.serialRemark,
                id: row.serial
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success("删除成功！")
                    this.trainDetailData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        splitStr(str){
            let result = ''
            if(str){
                const regex = /\[([^\]]+)\]/g;
                let match = regex.exec(str)
                result = match[1]
            }           
            return result
        },
        selectApplyDate(value){
            this.ruleForm.applyStartDate  = value[0].replace(/-/g, '')
            this.ruleForm.applyEndDate  = value[1].replace(/-/g, '')
        },
        selectApplyTime(value){
            this.ruleForm.applyStartTime  = value[0].replace(/:/g, '')
            this.ruleForm.applyEndTime  = value[1].replace(/:/g, '')
        },   
        selectEventDate(value){
            if(value){
                this.ruleForm.eventStartDate = value.replace(/-/g, '')
            }            
        },
        selectEventEndDate(value){
            if(value){
                this.ruleForm.eventEndDate = value.replace(/-/g, '')
            }            
        },
        selectEventTime(value){
            if(value){
                this.ruleForm.eventStartTime  = value[0].replace(/:/g, '')
                this.ruleForm.eventEndTime  = value[1].replace(/:/g, '')
            }            
        },
        handleChangeArea(value){
            this.cityList = []
            this.ruleForm.provinces = value
            this.ruleForm.city = ''
            let cityObj = this.areaList.filter(i=> i.label === value)
            this.cityList = cityObj[0].cities
        },
        handleChangecity(value){
            this.ruleForm.city = value
        },
        handleClose(){
            this.cancel()
        },
        cancel(){
            // this.$emit('update:visible',false)
            this.showAddTrainDialog = false
            this.resetForm('ruleForm')
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    }
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/views/training/components/addTrainDialog.vue